import React from 'react';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
  return (
    <div className="relative group">
      {children}
      <div className="absolute left-full top-1/2 -translate-y-1/2 ml-[6px] hidden group-hover:block">
        <div className="relative">
          {/* Tooltip content */}
          <div className="bg-[#222222] text-[#FFFFFF] text-[12px] font-normal px-2 py-1 rounded whitespace-nowrap">
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tooltip; 